import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { LogHandlerService } from 'src/app/services/log-handler.service';
import { ServiceViewModel } from 'src/app/view-models/service.viewmodel';
import { BaseComponent } from '../base.component';

@Component({
  selector: 'app-service',
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.scss']
})
export class ServiceComponent extends BaseComponent<ServiceViewModel> implements OnInit {

  constructor(commonService: CommonService, logService: LogHandlerService) {
    super(commonService,logService)
    this.viewModel=new ServiceViewModel();
   }

  ngOnInit(): void {
  }

}
